import { useTranslation } from 'react-i18next';

import { ConnectionFallback } from '../ConnectionFallback';

interface ConnectToInstagramProps {
  description: string;
  to: string;
}

export const ConnectToInstagram = ({ description, to }: ConnectToInstagramProps) => {
  const { t } = useTranslation('anychat');

  return (
    <ConnectionFallback
      imgSrc="/assets/anychat/connect-anychat.png"
      imgAlt={t('anychat.shared.connectToInstagram.alt')}
      title={t('anychat.shared.connectToInstagram.title')}
      description={description}
      link={to}
      linkLabel={t('anychat.shared.connectToInstagram.link')}
    />
  );
};
